import { fontBold } from 'style/styled-components/cssGlobalVariables';
// import { Breakpoints, MQ, MQ_NOT_TOUCH } from 'style/styled-components/cssMediaQueries';
import { styled } from 'components/ThemeConfigConnector/ThemeConfigConnnector';
import subPreviewBackground from 'assets/images/subtitles_preview.png';

export const SubSection = styled.div`
    margin-bottom: 16px;
`;

export const SectionTitle = styled.p`
    font-family: ${fontBold};
    margin-bottom: 8px;
`;

export const Hint = styled.p`
    color: var(--color-dark-body-70);
    margin-bottom: 24px;
`;

export const SubtitlePreview = styled.div`
    background: url(${subPreviewBackground});
    background-size: cover;
    width: 100%;
    height: 168px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 24px;
    text-align: center;
`;

export const SubtitlePreviewText = styled.p`
    display: inline-block;
    padding: 2px 4px;
`;

export const ButtonWrapper = styled.div`
    display: flex;
    gap: 12px;
`;
